
export const tradeLicenseFields = [
    {
        label: "Trade License Number*",
        name: "tradeLicenseNumber",
        type: "text",
        placeholder: "Enter Trade License Number",
        required: true,
        errorMessage: 'Trade License Number',
        component: 'input'
    },
    {
        label: "Trade License Expiry Date*",
        type: "date",
        name: "expiryDate",
        placeholder: "Enter Expiry Date",
        required: true,
        errorMessage: 'Trade License Expiry Date',
        component: 'input'
    }
];

export const membershipNumberFields = [
    {
        label: "Membership Number*",
        name: "membershipNumber",
        type: "text",
        placeholder: "Enter Membership Number",
        required: true,
        errorMessage: 'Membership Number',
        component: 'input'
    },
    {
        label: "Membership Expiry Date*",
        type: "date",
        name: "expiryDate",
        placeholder: "Enter Expiry Date",
        required: true,
        errorMessage: 'Membership Expiry Date',
        component: 'input'
    }
];

export const userLoginInfoFields = [
    {
        label: "Company Name*",
        name: "companyName",
        type: "text",
        placeholder: "Enter Company Name",
        required: true,
        errorMessage: 'Company Name',
        component: 'input'
    },
    {
        label: "Designation*",
        name: "designation",
        type: "text",
        placeholder: "Enter Designation",
        required: true,
        errorMessage: 'Designation',
        component: 'input'
    },
    {
        label: "First Name*",
        name: "firstName",
        type: "text",
        placeholder: "Enter First Name",
        required: true,
        errorMessage: 'First Name',
        component: 'input'
    },
    {
        label: "Last Name*",
        name: "lastName",
        type: "text",
        placeholder: "Enter Last Name",
        required: true,
        errorMessage: 'Last Name',
        component: 'input'
    },
    {
        label: "Email*",
        name: "email",
        type: "text",
        placeholder: "Enter Email",
        required: true,
        errorMessage: 'Email',
        component: 'input'
    },
    {
        label: "Phone Number*",
        name: "phoneNumber",
        type: "phone",
        placeholder: "Enter Phone Number",
        required: true,
        errorMessage: 'Phone Number',
        component: 'input'
    }
]